import BaseModel from './BaseModel'

export default class OrderModel extends BaseModel {
  get schema () {
    return {
      id: String,
      orderNumber: String,
      status: String
    }
  }

  prepareCreate () {
    this.baseClear()

    return this
  }

  prepareUpdate () {
    this.baseClear()

    return this
  }
}
